import React from 'react';
import { SystemStatusCheck } from '@/components/admin/SystemStatusCheck';
import AuthGuard from '@/components/common/AuthGuard';

export const TestingPage: React.FC = () => {
  return (
    <AuthGuard>
      <div className="min-h-screen bg-background p-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">🔧 Pre-Launch Testing</h1>
          <p className="text-muted-foreground mb-8">
            Running comprehensive system checks to verify all critical issues are resolved.
          </p>
          <SystemStatusCheck />
        </div>
      </div>
    </AuthGuard>
  );
};

export default TestingPage;